/* eslint-disable no-useless-escape */
export function getPWADisplayMode(): 'twa' | 'standalone' | 'fullscreen' | 'minimal-ui' | 'browser' | 'unknown' | 'window-controls-overlay' {
    if (document.referrer.startsWith('android-app://')) return 'twa';
    if (window.matchMedia('(display-mode: browser)').matches) return 'browser';
    if (window.matchMedia('(display-mode: standalone)').matches) return 'standalone';
    if (window.matchMedia('(display-mode: minimal-ui)').matches) return 'minimal-ui';
    if (window.matchMedia('(display-mode: fullscreen)').matches) return 'fullscreen';
    if (window.matchMedia('(display-mode: window-controls-overlay)').matches) return 'window-controls-overlay';

    return 'unknown';
}

// Function to extract browser version using regex
const browserVersion = (userAgent, regex) => {
    const match = userAgent.match(regex);
    return match ? match[2] : null;
};

export interface IBrowserInfo {
    name: 'unknown' | 'UCBrowser' | 'Edge' | 'GoogleBot' | 'Chromium' | 'Firefox' | 'IE' | 'Chrome' | 'Safari' | 'Opera';
    version: any;
}

// eslint-disable-next-line complexity
export const detectBrowser = () => {
    const { userAgent } = navigator;
    let browser: 'UCBrowser' | 'Edge' | 'GoogleBot' | 'Chromium' | 'Firefox' | 'IE' | 'Chrome' | 'Safari' | 'Opera' | 'unknown' = 'unknown';
    let version = null;
    // Detect browser name
    if (/ucbrowser/i.test(userAgent)) {
        browser = 'UCBrowser';
    } else if (/edg/i.test(userAgent)) {
        browser = 'Edge';
    } else if (/googlebot/i.test(userAgent)) {
        browser = 'GoogleBot';
    } else if (/chromium/i.test(userAgent)) {
        browser = 'Chromium';
    } else if (/firefox|fxios/i.test(userAgent) && !/seamonkey/i.test(userAgent)) {
        browser = 'Firefox';
    } else if (/; msie|trident/i.test(userAgent) && !/ucbrowser/i.test(userAgent)) {
        browser = 'IE';
    } else if (/chrome|crios/i.test(userAgent) && !/opr|opera|chromium|edg|ucbrowser|googlebot/i.test(userAgent)) {
        browser = 'Chrome';
    } else if (/safari/i.test(userAgent) && !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(userAgent)) {
        browser = 'Safari';
    } else if (/opr|opera/i.test(userAgent)) {
        browser = 'Opera';
    }
    // Detect browser version
    switch (browser) {
        case 'UCBrowser':
            version = browserVersion(userAgent, /(ucbrowser)\/([\d\.]+)/i);
            break;
        case 'Edge':
            version = browserVersion(userAgent, /(edge|edga|edgios|edg)\/([\d\.]+)/i);
            break;
        case 'GoogleBot':
            version = browserVersion(userAgent, /(googlebot)\/([\d\.]+)/i);
            break;
        case 'Chromium':
            version = browserVersion(userAgent, /(chromium)\/([\d\.]+)/i);
            break;
        case 'Firefox':
            version = browserVersion(userAgent, /(firefox|fxios)\/([\d\.]+)/i);
            break;
        case 'Chrome':
            version = browserVersion(userAgent, /(chrome|crios)\/([\d\.]+)/i);
            break;
        case 'Safari':
            version = browserVersion(userAgent, /(safari)\/([\d\.]+)/i);
            break;
        case 'Opera':
            version = browserVersion(userAgent, /(opera|opr)\/([\d\.]+)/i);
            break;
        case 'IE': {
            const tridentVersion = browserVersion(userAgent, /(trident)\/([\d\.]+)/i);
            // IE version is mapped using Trident version
            // IE/8.0 = Trident/4.0, IE/9.0 = Trident/5.0
            version = tridentVersion ? `${parseFloat(tridentVersion) + 4.0}` : '7.0';
            break;
        }
        default:
            version = '0.0.0.0';
            break;
    }
    return { name: browser, version };
};

export function getOS(): 'Mac OS' | 'iOS' | 'Windows' | 'Android' | 'Linux' | 'unknown' {
    let os:'Mac OS' | 'iOS' | 'Windows' | 'Android' | 'Linux' | 'unknown' = 'unknown';
    try {
        const { userAgent } = window.navigator;
        const platform = (window as any).navigator?.userAgentData?.platform || window.navigator.platform;
        const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
        const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (/Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    } catch (e) {
        return os;
    }
}

export function isIosOrSafari(): boolean {
    const os = getOS();
    const browser = detectBrowser();
    return os === 'iOS' || browser.name === 'Safari';
}
